import { setCartStore } from '../../StoresFunctions/cartStoreFunctions'

import request from '../Functions/ajax/request'

export default async function CartLoader ({ params })
{
	return { params, page: getPage({ params }) };
}

async function getPage ({ params })
{
	try
	{
		var { data:cart } = await request('/cart/get-cart')
		.config({ min_req_time: 0 })
		.post();
	}
	catch (update)
	{
		return;
	}

	setCartStore(cart);

	return { cart: cart };
}